import axios, { AUTH_PREFIX } from 'src/clients/axios';

/**
 * Get Business Partner Api Access Keys
 * @param {*} get
 */

export const getApiKeys = (params: any) => {
  //TODO change response after done error mapping
  return axios({
    url: `${AUTH_PREFIX}/auth/api-keys`,
    method: 'get',
    params,
  });
};
